import { CUSTOMER_ACCOUNT_AUTHORITY_LEVELS } from "@tastyworks/shared-utils/misc/constants"
import { RestResource } from "./common"
import { CUSTOMER_DESER, Customer } from "./customer"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class CustomerAuthority extends RestResource {
  authorityLevel = ""
  customer = new Customer()

  get isOwner() {
    return this.authorityLevel === CUSTOMER_ACCOUNT_AUTHORITY_LEVELS.OWNER
  }
}

export const CUSTOMER_AUTHORITY_DESER: SchemaDeSer<CustomerAuthority> =
  new SchemaDeSerBuilder(CustomerAuthority)
    .ofString("id")
    .ofString("authorityLevel")
    .ofNested("customer", CUSTOMER_DESER, Customer)
    .toDeSer()
